import api from '../callApi';

const completeLink = (apiRequestData, actionCompletedTime, isVisual) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime,
        isVisual
    };

    return api
        .post('Widget/CompleteLinkAsync', request, { useFingerprint: true })
        .then(response => {
            return response;
        });
};

export default completeLink;
